export default "__VITE_ASSET__KJqZWmUp__"